import {
  Delete,
  Get,
  getAPIUrl,
  Post,
  Put,
} from "../../../ApiServices/apiMethod";
import { HomePageService } from "../../../ApiServices/Axios/Index";

export const OffersEndpoint = {
  getOffers: `/admin/offers/list`,
  getOfferbyId: `/admin/content/details/`,
  deleteOffer: `/admin/offers/delete/`,
  editOffer: `/admin/offers/edit/`,
  addOffer: `/admin/offers/add`,
  uploadImage: `/admin/content/uploadImage`,
};

export const getOffers = (param = "") => {
  const url = getAPIUrl(OffersEndpoint.getOffers, param);
  return Get(HomePageService, url, true);
};
export const getOfferbyId = (param = "") => {
  const url = getAPIUrl(OffersEndpoint.getOfferbyId, param);
  return Get(HomePageService, url, true);
};
export const addOffer = (data, param = "") => {
  const url = getAPIUrl(OffersEndpoint.addOffer, param);
  return Post(HomePageService, url, data, true);
};

export const editOffer = (data, param = "") => {
  const url = getAPIUrl(OffersEndpoint.editOffer, param);
  return Put(HomePageService, url, data, true);
};

export const uploadImage = (data) => {
  const formData = new FormData();
  Object.keys(data).forEach((k) => {
    if (data[k]) {
      formData.append(k, data[k]);
    }
  });
  const url = getAPIUrl(OffersEndpoint.uploadImage);
  return Post(HomePageService, url, formData, true, true);
};
export const deleteOffer = (param = "") => {
  const url = getAPIUrl(OffersEndpoint.deleteOffer, param);
  return Delete(HomePageService, url, param);
};
